import type { RouteRecordRaw } from 'vue-router';

export const profileRoute: RouteRecordRaw = {
  path: '/profile',
  name: 'Profile',
  component: () => import('./pages/ProfilePage.vue'),
  meta: {
    depth: 1,
  },
};
